import React from 'react'
import { FormattedMessage } from 'react-intl'

import { ISummaryContent } from '../../shared/summary/Summary'

export const summayContent: ISummaryContent[] = [
  {
    title: (
      <FormattedMessage
        id='ui.TermsAndConditions.summaryContentOne.title'
        defaultMessage='Définitions'
      />
    ),
    hrefId: 'Definitions',
    article: '1',
  },
  {
    title: (
      <FormattedMessage
        id='ui.TermsAndConditions.summaryContentTwo.title'
        defaultMessage='Informations générales – Contact'
      />
    ),
    hrefId: 'GeneralInformations',
    article: '2',
  },
  {
    title: (
      <FormattedMessage
        id='ui.TermsAndConditions.summaryContentThree.title'
        defaultMessage='Objet des CGU'
      />
    ),
    hrefId: 'CGUPurpose',
    article: '3',
  },
  {
    title: (
      <FormattedMessage
        id='ui.TermsAndConditions.summaryContentFour.title'
        defaultMessage='Acceptation des CGU'
      />
    ),
    hrefId: 'CGUApproval',
    article: '4',
  },
  {
    title: (
      <FormattedMessage
        id='ui.TermsAndConditions.summaryContentFive.title'
        defaultMessage='Durée des CGU'
      />
    ),
    hrefId: 'CGUDuration',
    article: '5',
  },
  {
    title: (
      <FormattedMessage
        id='ui.TermsAndConditions.summaryContentSix.title'
        defaultMessage='Modification des CGU'
      />
    ),
    hrefId: 'CGUChanges',
    article: '6',
  },
  {
    title: (
      <FormattedMessage
        id='ui.TermsAndConditions.summaryContentSeven.title'
        defaultMessage='Description du Service et des Prestations de Voyages d’affaires'
      />
    ),
    hrefId: 'DescriptionOfTheServiceAndBusinessTravelBenefits',
    article: '7',
    subArticles: [
      {
        title: (
          <FormattedMessage
            id='ui.TermsAndConditions.summaryContentSeven.subArticleOne.title'
            defaultMessage='Description du Service'
          />
        ),
        hrefId: 'ServiceDescription',
        article: '7.1',
      },
      {
        title: (
          <FormattedMessage
            id='ui.TermsAndConditions.summaryContentSeven.subArticleTwo.title'
            defaultMessage='Présentation des Prestations de Voyages d’affaires sur le Site'
          />
        ),
        hrefId: 'PresentationOfBusinessTravelServicesOnTheSite',
        article: '7.2',
      },
    ],
  },
  {
    title: (
      <FormattedMessage
        id='ui.TermsAndConditions.summaryContentEight.title'
        defaultMessage='Prérequis et droit d’accès au Service'
      />
    ),
    hrefId: 'ServicePrerequisitesAndAccessRights',
    article: '8',
    subArticles: [
      {
        title: (
          <FormattedMessage
            id='ui.TermsAndConditions.summaryContentEight.subArticleOne.title'
            defaultMessage='Conditions d’éligibilité au Service'
          />
        ),
        hrefId: 'ServiceEligibilityConditions',
        article: '8.1',
      },
      {
        title: (
          <FormattedMessage
            id='ui.TermsAndConditions.summaryContentEight.subArticleTwo.title'
            defaultMessage='Prérequis techniques pour l’accès au Site'
          />
        ),
        hrefId: 'TechnicalPrerequisitesForAccessToTheSite',
        article: '8.2',
      },
      {
        title: (
          <FormattedMessage
            id='ui.TermsAndConditions.summaryContentEight.subArticleThree.title'
            defaultMessage='Droit d’accès et d’utilisation du Site'
          />
        ),
        hrefId: 'AccessRightAndUseOfTheSite',
        article: '8.3',
      },
    ],
  },
  {
    title: (
      <FormattedMessage
        id='ui.TermsAndConditions.summaryContentNine.title'
        defaultMessage='Utilisation du Site'
      />
    ),
    hrefId: 'UseOfTheSite',
    article: '9',
    subArticles: [
      {
        title: (
          <FormattedMessage
            id='ui.TermsAndConditions.summaryContentNine.subArticleOne.title'
            defaultMessage='Compte'
          />
        ),
        hrefId: 'Account',
        article: '9.1',
        subArticles: [
          {
            title: (
              <FormattedMessage
                id='ui.TermsAndConditions.summaryContentNine.subArticleOne.subArticleOne.title'
                defaultMessage='Création d’un Compte'
              />
            ),
            hrefId: 'AccountCreation',
            article: '9.1.1',
          },
          {
            title: (
              <FormattedMessage
                id='ui.TermsAndConditions.summaryContentNine.subArticleOne.subArticleTwo.title'
                defaultMessage='Confidentialité et sécurité des Identifiants'
              />
            ),
            hrefId: 'ConfidentialityAndSecurityOfIdentifiers',
            article: '9.1.2',
          },
          {
            title: (
              <FormattedMessage
                id='ui.TermsAndConditions.summaryContentNine.subArticleOne.subArticleThree.title'
                defaultMessage='Suppression du Compte '
              />
            ),
            hrefId: 'AccountDeletion',
            article: '9.1.3',
          },
        ],
      },
      {
        title: (
          <FormattedMessage
            id='ui.TermsAndConditions.summaryContentNine.subArticleTwo.title'
            defaultMessage='Processus de Réservation de Prestations de Voyages d’affaires sur le Site'
          />
        ),
        hrefId: 'BusinessTravelServicesBookingProcessOnTheSite',
        article: '9.2',
        subArticles: [
          {
            title: (
              <FormattedMessage
                id='ui.TermsAndConditions.summaryContentNine.subArticleTwo.subArticleOne.title'
                defaultMessage='Choix des Prestations de Voyages d’affaires sur le Site'
              />
            ),
            hrefId: 'ChoiceOfBusinessTravelServicesOnTheSite',
            article: '9.2.1',
          },
          {
            title: (
              <FormattedMessage
                id='ui.TermsAndConditions.summaryContentNine.subArticleTwo.subArticleTwo.title'
                defaultMessage='Modalités de Demande de réservation'
              />
            ),
            hrefId: 'BookingRequestTerms',
            article: '9.2.2',
          },
          {
            title: (
              <FormattedMessage
                id='ui.TermsAndConditions.summaryContentNine.subArticleTwo.subArticleThree.title'
                defaultMessage='Réservation de Prestations de Voyages d’affaires'
              />
            ),
            hrefId: 'BookingOfBusinessTravelServices',
            article: '9.2.3',
          },
          {
            title: (
              <FormattedMessage
                id='ui.TermsAndConditions.summaryContentNine.subArticleTwo.subArticleFour.title'
                defaultMessage='Paiement de la Réservation'
              />
            ),
            hrefId: 'BookingPayment',
            article: '9.2.4',
          },
        ],
      },
    ],
  },
  {
    title: (
      <FormattedMessage
        id='ui.TermsAndConditions.summaryContentTen.title'
        defaultMessage='Maintenance et mise à jour du Site'
      />
    ),
    hrefId: 'SiteMaintenanceAndUpdate',
    article: '10',
  },
  {
    title: (
      <FormattedMessage
        id='ui.TermsAndConditions.summaryContentEleven.title'
        defaultMessage='Responsabilité au titre de la navigation sur le Site'
      />
    ),
    hrefId: 'LiabilityForNavigationOnTheSite',
    article: '11',
  },
  {
    title: (
      <FormattedMessage
        id='ui.TermsAndConditions.summaryContentTwelve.title'
        defaultMessage='Propriété intellectuelle'
      />
    ),
    hrefId: 'IntellectualProperty',
    article: '12',
  },
  {
    title: (
      <FormattedMessage
        id='ui.TermsAndConditions.summaryContentThirteen.title'
        defaultMessage='Données personnelles'
      />
    ),
    hrefId: 'PersonalData',
    article: '13',
  },
  {
    title: (
      <FormattedMessage
        id='ui.TermsAndConditions.summaryContentFourteen.title'
        defaultMessage='Convention de preuve'
      />
    ),
    hrefId: 'ProofConvention',
    article: '14',
  },
  {
    title: (
      <FormattedMessage
        id='ui.TermsAndConditions.summaryContentFifteen.title'
        defaultMessage='Divisibilité'
      />
    ),
    hrefId: 'Divisibility',
    article: '15',
  },
  {
    title: (
      <FormattedMessage
        id='ui.TermsAndConditions.summaryContentSixteen.title'
        defaultMessage='Droit applicable et résolution des différends'
      />
    ),
    hrefId: 'ApplicableLawAndDisputeResolution',
    article: '16',
  },
]
